function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#F472B6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5062 12.4674L8.25425 9.2445L5.02779 12.5L4.03258 11.5048L7.25338 8.25212L4 5.02779L4.99521 4.03258L8.24504 7.25054L11.4644 4L12.4674 4.99379L9.24733 8.24292L12.5 11.4644L11.5062 12.4674Z",
  fill: "white"
});

function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.1709762eaceda17e35c64d82e8abd69a.svg";
export { ForwardRef as ReactComponent };